/**
 * A helper that returns a promise after waiting for a specified time
 * This is handy for when you want to wait for a moment!
 *
 * @param delay - how long to wait defaults to 1 second
 */
export function waitFor(delay = 1000): Promise<void> {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve();
    }, delay);
  });
}
